<template>
  <div id="app" style="padding-top: 40px; height: 100vh; overflow: auto;" :style="{ 'background-image': `url(${coverImage})`, 'background-repeat': 'no-repeat', 'background-size': 'cover' }">
    <h1 style="font-size: 35px; color: white; text-align: left; margin-left: 80px; margin-top: -20px;">{{ title }}</h1>
    <br><br>
    <div class="board">
      <h1>註冊</h1>
      <el-row :gutter="20">
        <el-col :span="12" style="padding-top: 15px;">
          <div class="content">
            <el-row :gutter="5">
              <el-col :span="4">
                <i class="el-icon-s-marketing" style="color: #57c447; font-size: 30px;"></i>
                <!-- <mu-icon value="timeline" color="green" size="30"/> -->
              </el-col>
              <el-col :span="20">
                <div class="title">ChatApp 解決方案</div>
                <div class="des">EILIS提供FB、LINE雙平台Chatbot系統服務、數位會員卡系統、串接第三方服務API，例如:官方網站、POS、會員系統...等更多服務，深度整合企業多元系統，協助打造完整ChatApp使用體驗。</div>
              </el-col>
            </el-row>
          </div>
          <div class="content">
            <el-row :gutter="5">
              <el-col :span="4">
                <i class="el-icon-s-custom" style="color: #f24; font-size: 30px;"></i>
                <!-- <mu-icon value="people" color="red" size="30"/> -->
              </el-col>
              <el-col :span="20">
                <div class="title">數位會員系統掌握消費頻次</div>
                <div class="des">紀錄會員資料及消費頻次，設定自動化情境腳本，建立主動訊息傳遞渠道，串連線上線下互導流，提高消費者回購率。</div>
              </el-col>
            </el-row>
          </div>
          <div class="content">
            <el-row :gutter="5">
              <el-col :span="4">
                <i class="el-icon-star-on" style="color: #34c6d3; font-size: 30px;"></i>
                <!-- <mu-icon value="stop" color="#34c6d3" size="30"/> -->
              </el-col>
              <el-col :span="20">
                <div class="title">品牌會員忠誠度計畫</div>
                <div class="des">EILIS 協助企業打造「品牌會員忠誠度計畫」，透過社群數位會員，紀錄會員資料、點數等級差異化經營、點數商城、推薦機制...等更多服務串連線上線下互導流，建立起品牌和會員之間的互動渠道，培養更多品牌忠誠會員。</div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="12" style="margin-top: -5px;">
          <mu-text-field icon="account_circle" :error-text="isName" label-float label="用戶名稱" v-model="name" style="width: 320px;">
          </mu-text-field>
          <mu-text-field icon="perm_phone_msg" :error-text="isPhone" label-float label="用戶電話，例：0912345678" v-model="phone" style="width: 320px;">
          </mu-text-field>
          <mu-text-field icon="email" :error-text="isEmail" label-float label="用戶 Email"  v-model="email" style="width: 320px;">
          </mu-text-field>
          <mu-text-field icon="lock" :error-text="isPassword" type="password" label-float label="請輸入密碼" v-model="password" style="width: 320px;">
          </mu-text-field>
          <mu-text-field icon="lock" :error-text="samePassword" type="password" label-float label="請再次輸入密碼" v-model="password2" style="width: 320px;">
          </mu-text-field>
          <el-button style="width: 300px; margin-left: 20px; font-size: 18px; margin-top: 10px;" type="success" @click="checkPhone">註冊</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="ab">
      <mu-button flat class="register">
        <!-- <i class="el-icon-user-solid" style="margin-right: 5px; transform: translateY(1px);"></i> -->
        <!-- <mu-icon left value="person_add" style="transform: scale(0.8);"></mu-icon> -->
        註冊
      </mu-button>
    </div>
    <div class="bc">
      <mu-button flat class="register" @click="login">
        <!-- <mu-icon left value="fingerprint" style="transform: scale(0.8);"></mu-icon> -->
        登入
      </mu-button>
    </div>
    <!-- dialog -->
    <el-dialog title="系統通知" :visible="dialogMsg">
      <span>{{ result }}</span>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="result !== '請稍候...'" type="primary" @click="dialogMsg = false" plain>關閉</el-button>
        <el-button v-if="result !== '請稍候...'" type="primary" @click="goToLogin">前往登入頁</el-button>
      </div>
    </el-dialog>
    <!-- dialog -->
    <!-- 電話驗證 -->
    <el-dialog title="電話驗證" :visible.sync="phoneDia">
      <div style="margin-bottom: 10px;">已發送驗證碼，請至行動裝置上確認</div>
      <mu-text-field :error-text="rightCode" v-model="verCode" placeholder="請輸入驗證碼"></mu-text-field>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" :disabled="count !== 0" @click="sendPhoneVer">重新發送 {{ count === 0 ? '' : count }}</el-button>
        <el-button type="primary" @click="sendVerify">驗證</el-button>
      </span>
    </el-dialog>
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px; color: #fff;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';


export default {
  name: 'HelloWorld',
  data() {
    return {
      title: 'EILIS 智慧互動',
      images: [
        'https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
      ],
      name: '',
      email: '',
      phone: '',
      password: '',
      password2: '',
      wrongPass: false,
      dialogMsg: false,
      phoneDia: false,
      count: 0,
      result: '請稍候...',
      code: '',
      verCode: '',
      error: '',
      isName: '',
      isPhone: '',
      isEmail: '',
      isPassword: '',
      samePassword: '',
      rightCode: '',
      coverImage: '',
    }
  },
  mounted() {
    this.coverImage = this.images[Math.floor(Math.random() * this.images.length)];
    this.checkUser();
  },
  methods: {
    ...mapActions({
      getUserDetail: 'getUserDetail',
      register: 'register',
      sendSMS: 'sendSMS'
    }),
    goToLogin() {
      this.$router.push('/login');
    },
    sendVerify() {
      if (this.verCode) {
        if (this.code === this.verCode) {
          this.rightCode = '';
          this.dialogMsg = true;
          this.register({ phone: this.phone, UserName: this.name, Email: this.email, Password: this.password })
            .then((res) => {
              if (res.data.Message === '註冊成功') {
                this.result    = '註冊成功，請重新登入！';
                this.name      = '';
                this.email     = '';
                this.phone     = '';
                this.password  = '';
                this.password2 = '';
              }
              else {
                this.result = res.data.Message;
              }
            })
        }
        else {
          this.rightCode = '驗證碼錯誤！';
        }
      }
      else {
        this.rightCode = '請輸入6位數驗證碼！';
      }
    },
    checkUser() {
      const loading = this.$loading({
        lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
      });
      this.getUserDetail().then((res) => {
        if (res.data.detail) {
          localStorage.setItem('MemberData', JSON.stringify(res.data.detail));
          this.$router.push('/mainpage');
          loading.close();
        }
        else {
          loading.close();
        }
      })
    },
    login() {
      this.$router.push('/login');
    },
    countDown() {
      this.count = 60;
      setInterval(() => {
        if (this.count > 0) {
          this.count -= 1
        }
      }, 1000)
    },
    sendPhoneVer() {
      this.countDown();
      const random = new Array('0','1','2','3','4','5','6','7','8','9');
      let code = '';
      for (let e = 0; e < 6; e += 1) {
        const index = Math.floor(Math.random() * 10);
        code += random[index];
      }
      this.code = code;
      this.sendSMS({ phone: this.phone, code: code });
    },
    checkPhone() {
      if (this.name && this.password && this.phone && this.email) {
        if (this.password.length >= 6) {
          this.isPassword = '';
          if (this.password === this.password2) {
            this.samePassword = '';
            this.phoneDia = true;
            this.sendPhoneVer();
          }
          else {
            this.samePassword = '密碼不符合';
          }
        }
        else {
          this.isPassword = '密碼長度至少要 6 碼';
        }
      }
      else {
        if (!this.name)     { this.isName     = '姓名未必填' }
        if (!this.phone)    { this.isPhone    = '電話為必填' }
        if (!this.password) { this.isPassword = '密碼為必填' }
        if (!this.email)    { this.isEmail    = 'Email 為必填' }
        if (this.name)      { this.isName     = '' }
        if (this.phone)     { this.isPhone    = '' }
        if (this.email)     { this.isEmail    = '' }
        if (this.password)  { this.isPassword = '' }
      }
    }
  }
}
</script>

<style scoped>
.register {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  width: 100px;
}
.board {
  padding-top: 10px;
  padding-left: 10px;
  border-radius: 5px;
  margin: 0px auto;
  max-width: 850px;
  min-width: 500px;
  height: 590px;
  background-color: rgba(255, 255, 255, 0.961);
  -webkit-animation-name: myframes;
          animation-name: myframes;
  -webkit-animation-duration: 500ms;
          animation-duration: 500ms;
  -webkit-animation-timing-function: ease-in-out;
          animation-timing-function: ease-in-out;
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
          animation-iteration-count: 1;
  -webkit-animation-direction: normal;
          animation-direction: normal;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}
.box.is-paused {
  -webkit-animation-play-state: paused;
          animation-play-state: paused;

}
@keyframes myframes {
  0% {
    -webkit-transform: scale(0) rotate(0deg);
            transform: scale(0) rotate(0deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1) rotate(0deg);
            transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}
.content {
  margin: 20px;
  margin-top: 10px;
  margin-left: 20px;
}
.icon {
  color: #34c6d3;
  display: inline-block;
  text-align: center;
}
.title {
  font-size: 20px;
  font-weight: 400;
  margin-top: 0px;
  text-align: left;
}
.des {
  font-size: 13px;
  margin-top: 10px;
  width: 98%;
  text-align: left;
}
.el-input-group__prepend {
  width: 70px;
  background-color: #777;
  color: #fff;
  font-weight: 500;
  font-size: 15px;
}
.ab {
  position: absolute;
  top: 20px;
  right: 70px;
}
.bc {
  position: absolute;
  top: 20px;
  right: 160px;
}
</style>